import React from 'react';

const LoadingIndicator = React.memo(({ color, numberSegments }) => {
    return (
        <div className="lds-ring">
            {Array.from(Array(numberSegments).keys()).map(i => <div key={i} style={{
                 borderBottomColor: color,
                 animationDelay: `-${0.5 - 1.0 * i / numberSegments}s`
             }} />)}
        </div>
    );
});

LoadingIndicator.defaultProps = {
    color: "#000000",
    numberSegments: 4
};

export default LoadingIndicator;

